if (!customElements.get('product-info')) {

  customElements.define(

    'product-info',

    class ProductInfo extends HTMLElement {

      quantityInput = undefined;

      quantityForm = undefined;

      onVariantChangeUnsubscriber = undefined;

      cartUpdateUnsubscriber = undefined;

      abortController = undefined;

      pendingRequestUrl = null;

      variantSelectRow1 = false;

      preProcessHtmlCallbacks = [];

      postProcessHtmlCallbacks = [];

      constructor() {

        super();

        this.quantityInput = this.querySelector('.quantity__input');

      }

      connectedCallback() {

        this.initializeProductSwapUtility();

        this.onVariantChangeUnsubscriber = subscribe(

          PUB_SUB_EVENTS.optionValueSelectionChange,

          this.handleOptionValueChange.bind(this)

        );

        this.initQuantityHandlers();

        this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));

      }

      addPreProcessCallback(callback) {

        this.preProcessHtmlCallbacks.push(callback);

      }

      initQuantityHandlers() {

        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector('.product-form__quantity');

        if (!this.quantityForm) return;

        this.setQuantityBoundries();

        if (!this.dataset.originalSection) {

          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));

        }

      }

      disconnectedCallback() {

        this.onVariantChangeUnsubscriber();

        this.cartUpdateUnsubscriber?.();

      }

      initializeProductSwapUtility() {

        this.preProcessHtmlCallbacks.push((html) =>

          html.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.add('scroll-trigger--cancel'))

        );

        this.postProcessHtmlCallbacks.push((newNode) => {

          window?.Shopify?.PaymentButton?.init();

          window?.ProductModel?.loadShopifyXR();

        });

      }

      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {

        if (!this.contains(event.target)) return;

        this.variantSelectRow1 = !!event.target.closest('.pvp-row-1');

        this.resetProductFormState();

        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;

        this.pendingRequestUrl = productUrl;

        const shouldSwapProduct = this.dataset.url !== productUrl;

        const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;

        // IMPORTANT — linked shades are separate Shopify products, not true

        // variants of the same product. For a cross-product shade change we

        // perform a real navigation to the CLEAN product URL. This guarantees

        // that third-party product-context apps such as CWILL/Trustoo boot with

        // the newly selected product instead of staying bound to the product

        // that originally loaded the page. It also prevents Shopify's default

        // ?variant=... query from being added to linked-product URLs.

        if (shouldSwapProduct && this.dataset.updateUrl === 'true') {

          let cleanProductUrl = productUrl;

          try {

            const parsed = new URL(productUrl, window.location.origin);

            parsed.search = '';

            parsed.hash = '';

            cleanProductUrl = parsed.pathname;

          } catch (e) {}

          // Preserve the user's viewport so the full product-context refresh

          // does not feel like an abrupt jump back to the top.

          try {

            sessionStorage.setItem(

              'krimaa:linked-product-navigation',

              JSON.stringify({

                x: window.scrollX,

                y: window.scrollY,

                path: new URL(cleanProductUrl, window.location.origin).pathname,

                time: Date.now()

              })

            );

          } catch (e) {}

          window.location.assign(cleanProductUrl);

          return;

        }

        // Same-product variants keep the theme's normal AJAX behaviour.

        this.suppressVariantFocus = false;

        this.renderProductInfo({

          requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, false),

          targetId: target.id,

          callback: this.handleUpdateProductInfo(productUrl),

        });

      }

      resetProductFormState() {

        const productForm = this.productForm;

        productForm?.toggleSubmitButton(true);

        productForm?.handleErrorMessage();

      }

      handleSwapProduct(productUrl, updateFullPage) {

        return (html) => {

          this.productModal?.remove();

          const selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';

          const productInfoSource = html.querySelector(selector);

          if (!productInfoSource) return;

          const variant = this.getSelectedVariant(productInfoSource);

          /*

           * SMOOTH CROSS-PRODUCT SHADE SWAP

           *

           * Do NOT replace the entire <main>.

           * Replacing <main> caused the mobile blink + top jump.

           *

           * Instead:

           * 1) update URL/title

           * 2) transition only <product-info> (same feel as normal variant update)

           * 3) refresh the product tabs section separately

           * 4) preserve the exact viewport

           */

          const savedScrollX = window.scrollX;

          const savedScrollY = window.scrollY;

          const docEl = document.documentElement;

          const previousScrollBehavior = docEl.style.scrollBehavior;

          const previousOverflowAnchor = docEl.style.overflowAnchor;

          docEl.style.setProperty('scroll-behavior', 'auto', 'important');

          docEl.style.setProperty('overflow-anchor', 'none');

          try {

            if ('scrollRestoration' in history) {

              history.scrollRestoration = 'manual';

            }

          } catch (e) {}

          this.updateURL(productUrl, null);

          const incomingTitle = html.querySelector('head title');

          const currentTitle = document.querySelector('head title');

          if (incomingTitle && currentTitle) {

            currentTitle.innerHTML = incomingTitle.innerHTML;

          }

          const restoreViewport = () => {

            const maxY = Math.max(

              0,

              document.documentElement.scrollHeight - window.innerHeight

            );

            const targetY = Math.min(savedScrollY, maxY);

            if (

              Math.abs(window.scrollX - savedScrollX) > 1 ||

              Math.abs(window.scrollY - targetY) > 1

            ) {

              window.scrollTo({

                left: savedScrollX,

                top: targetY,

                behavior: 'auto'

              });

            }

          };

          if (updateFullPage) {

            /*

             * TRUSTOO / CWILL STAR-RATING PRESERVATION

             *

             * The Trustoo app block below the product title is already a LIVE

             * third-party widget. The fetched product HTML only contains a fresh

             * app placeholder, and Trustoo does not reliably boot that placeholder

             * after this custom AJAX product swap. If we replace the live block,

             * the stars disappear.

             *

             * Keep the existing live Trustoo app block and move it into the

             * incoming product-info before the theme transition runs. Foundation

             * shades are intentionally in the same Trustoo Product Group, so the

             * aggregate rating/review count is shared across the group.

             */

            const nextProductId = productInfoSource.dataset.productId || '';

            const looksLikeTrustooBlock = (node) => {

              if (!node) return false;

              const htmlText = (node.outerHTML || '').toLowerCase();

              const visibleText = (node.textContent || '').toLowerCase();

              return (

                htmlText.includes('vstar') ||

                htmlText.includes('trustoo') ||

                htmlText.includes('cwill') ||

                visibleText.includes('review')

              );

            };

            const currentAppBlocks = Array.from(

              this.querySelectorAll('.product-app-block')

            );

            const incomingAppBlocks = Array.from(

              productInfoSource.querySelectorAll('.product-app-block')

            );

            currentAppBlocks.forEach((liveBlock, index) => {

              if (!looksLikeTrustooBlock(liveBlock)) return;

              let targetBlock = incomingAppBlocks.find(

                (candidate) => looksLikeTrustooBlock(candidate)

              );

              // Server-side app placeholders can be nearly empty, so fall back

              // to the same app-block position. In this template the first app

              // block is the CWILL/Trustoo Star rating widget.

              if (!targetBlock) {

                targetBlock = incomingAppBlocks[index] || null;

              }

              if (!targetBlock || targetBlock === liveBlock) return;

              // If Trustoo emitted product-id attributes inside the live block,

              // point those attributes at the newly selected shade/product.

              if (nextProductId) {

                if (liveBlock.hasAttribute('data-product-id')) {

                  liveBlock.setAttribute('data-product-id', nextProductId);

                }

                liveBlock

                  .querySelectorAll('[data-product-id]')

                  .forEach((element) => {

                    element.setAttribute('data-product-id', nextProductId);

                  });

              }

              targetBlock.replaceWith(liveBlock);

            });

            /*

             * Important:

             * use the theme's existing transition utility ONLY on product-info.

             * This keeps the familiar smooth variant-change feel and avoids

             * blanking/replacing the whole page.

             */

            /*
             * KRIMAA LINKED-SHADE SWAP:
             * Keep the theme's normal first page-load animation, but once the
             * product page is open, shade-to-shade AJAX swaps should update
             * instantly without the repeated fade / slide-up transition.
             */
            const isKrimaaLinkedShadeSwap =
              this.getAttribute('data-krimaa-shade-loading') === 'true';

            if (isKrimaaLinkedShadeSwap) {
              this.preProcessHtmlCallbacks.forEach((callback) => {
                try {
                  callback(productInfoSource);
                } catch (error) {
                  console.error('[Krimaa pre-swap callback]', error);
                }
              });

              /*
               * Use the fetched product-info node directly (not a clone).
               * This preserves the live Trustoo/CWILL block moved above.
               */
              this.replaceWith(productInfoSource);

              this.postProcessHtmlCallbacks.forEach((callback) => {
                try {
                  callback(productInfoSource);
                } catch (error) {
                  console.error('[Krimaa post-swap callback]', error);
                }
              });
            } else {
              HTMLUpdateUtility.viewTransition(
                this,
                productInfoSource,
                this.preProcessHtmlCallbacks,
                this.postProcessHtmlCallbacks
              );
            }

            // Keep Shopify/Trustoo product globals aligned with the URL after a

            // cross-product shade swap. This helps app actions read the current

            // product instead of the product that first booted the page.

            if (nextProductId) {

              const numericProductId = Number(nextProductId);

              const globalProductId = Number.isFinite(numericProductId)

                ? numericProductId

                : nextProductId;

              try {

                if (window.meta?.product) {

                  window.meta.product.id = globalProductId;

                }

              } catch (e) {}

              try {

                if (window.ShopifyAnalytics?.meta?.product) {

                  window.ShopifyAnalytics.meta.product.id = globalProductId;

                }

              } catch (e) {}

              try {

                if (window.Shopify?.Analytics?.meta?.product) {

                  window.Shopify.Analytics.meta.product.id = globalProductId;

                }

              } catch (e) {}

            }

            /*

             * Update the lower Product Details tabs independently.

             * The section ID remains the same across these foundation products.

             * Doing this outside <main> replacement prevents the visible blink.

             */

            const incomingTabs = html.querySelector('.section-tabbed-content');

            const currentTabs = document.querySelector('.section-tabbed-content');

            if (incomingTabs && currentTabs) {

              /*

               * IMPORTANT — keep the existing Trustoo review mount alive.

               * Trustoo/CWILL initializes the real review UI on the original

               * .custom-vstar-review-widget node. Replacing the whole tabs

               * section destroys that live node and the widget becomes blank.

               *

               * We therefore:

               * 1) remember the currently selected tab,

               * 2) import the new product's tab content,

               * 3) MOVE the existing Trustoo mount into the imported Reviews tab,

               * 4) restore the selected tab state,

               * 5) replace the section.

               *

               * Because the foundation shades are in the same Trustoo product

               * group, preserving the live review mount is the correct behaviour.

               */

              const importedTabs = document.importNode(incomingTabs, true);

              const currentSelectedTab = currentTabs.querySelector(

                '[role="tab"][aria-selected="true"]'

              );

              const selectedTabText = (currentSelectedTab?.textContent || '')

                .trim()

                .toLowerCase();

              // Preserve the LIVE Trustoo mount (including its rendered DOM,

              // observers and event handlers) instead of creating a new empty div.

              const liveReviewMount = currentTabs.querySelector(

                '.custom-vstar-review-widget'

              );

              const incomingReviewMount = importedTabs.querySelector(

                '.custom-vstar-review-widget'

              );

              if (liveReviewMount && incomingReviewMount) {

                // Keep the already-rendered Trustoo review DOM alive. This is

                // the key to avoiding the blank Reviews panel after a shade swap.

                // Only update product-id attributes that Trustoo has already

                // emitted; do not destroy/re-bootstrap the widget.

                if (nextProductId) {

                  if (liveReviewMount.hasAttribute('data-product-id')) {

                    liveReviewMount.setAttribute('data-product-id', nextProductId);

                  }

                  liveReviewMount

                    .querySelectorAll('[data-product-id]')

                    .forEach((element) => {

                      element.setAttribute('data-product-id', nextProductId);

                    });

                }

                incomingReviewMount.replaceWith(liveReviewMount);

              }

              // Restore whichever tab was open before the product/shade swap.

              const importedTabButtons = Array.from(

                importedTabs.querySelectorAll('.tab-grand [role="tab"]')

              );

              let tabToRestore = null;

              if (selectedTabText) {

                tabToRestore = importedTabButtons.find(

                  (button) =>

                    (button.textContent || '').trim().toLowerCase() === selectedTabText

                );

              }

              if (!tabToRestore) {

                tabToRestore =

                  importedTabButtons.find(

                    (button) => button.getAttribute('aria-selected') === 'true'

                  ) || importedTabButtons[0];

              }

              importedTabButtons.forEach((button) => {

                const isSelected = button === tabToRestore;

                button.setAttribute('aria-selected', isSelected ? 'true' : 'false');

                button.setAttribute('tabindex', isSelected ? '0' : '-1');

                const panelId = button.getAttribute('aria-controls');

                if (!panelId) return;

                const panel = importedTabs.querySelector(

                  `#${CSS.escape(panelId)}`

                );

                if (!panel) return;

                if (isSelected) {

                  panel.removeAttribute('hidden');

                  panel.setAttribute('aria-hidden', 'false');

                } else {

                  panel.setAttribute('hidden', '');

                  panel.setAttribute('aria-hidden', 'true');

                }

              });

              // Keep the current section wrapper position stable.

              currentTabs.replaceWith(importedTabs);

              // Trustoo sometimes needs a layout pass after being moved from a

              // hidden tab / detached imported section back into the document.

              requestAnimationFrame(() => {

                window.dispatchEvent(new Event('resize'));

                if (tabToRestore) {

                  const restoredPanelId = tabToRestore.getAttribute('aria-controls');

                  const restoredPanel = restoredPanelId

                    ? document.getElementById(restoredPanelId)

                    : null;

                  tabToRestore.dispatchEvent(

                    new CustomEvent('krimaa:tab-shown', {

                      bubbles: true,

                      detail: {

                        panel: restoredPanel,

                        tab: tabToRestore

                      }

                    })

                  );

                }

              });

            }

            requestAnimationFrame(() => {

              restoreViewport();

              try {

                window.KrimaaProductPage?.rehydrate?.();

              } catch (e) {}

              try {

                window.krimaaFitPdpMedia?.();

              } catch (e) {}

              requestAnimationFrame(() => {

                restoreViewport();

              });

            });

            // A tiny late correction for mobile image/font settling.

            setTimeout(restoreViewport, 100);

            setTimeout(() => {

              if (previousScrollBehavior) {

                docEl.style.scrollBehavior = previousScrollBehavior;

              } else {

                docEl.style.removeProperty('scroll-behavior');

              }

              if (previousOverflowAnchor) {

                docEl.style.overflowAnchor = previousOverflowAnchor;

              } else {

                docEl.style.removeProperty('overflow-anchor');

              }

            }, 180);

          } else {

            HTMLUpdateUtility.viewTransition(

              this,

              productInfoSource,

              this.preProcessHtmlCallbacks,

              this.postProcessHtmlCallbacks

            );

            requestAnimationFrame(() => {

              restoreViewport();

              try {

                window.KrimaaProductPage?.rehydrate?.();

              } catch (e) {}

              setTimeout(() => {

                if (previousScrollBehavior) {

                  docEl.style.scrollBehavior = previousScrollBehavior;

                } else {

                  docEl.style.removeProperty('scroll-behavior');

                }

                if (previousOverflowAnchor) {

                  docEl.style.overflowAnchor = previousOverflowAnchor;

                } else {

                  docEl.style.removeProperty('overflow-anchor');

                }

              }, 120);

            });

          }

        };

      }

      renderProductInfo({ requestUrl, targetId, callback }) {

        this.abortController?.abort();

        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })

          .then((response) => response.text())

          .then((responseText) => {

            this.pendingRequestUrl = null;

            const html = new DOMParser().parseFromString(responseText, 'text/html');

            callback(html);

          })

          .then(() => {

            if (this.suppressVariantFocus) {

              this.suppressVariantFocus = false;

              return;

            }

            // Same-product variant update only.

            const selectedTarget = document.getElementById(targetId);

            if (selectedTarget) {

              try {

                selectedTarget.focus({ preventScroll: true });

              } catch (e) {}

            }

          })

          .catch((error) => {

            if (error.name === 'AbortError') {

              console.log('Fetch aborted by user');

            } else {

              console.error(error);

            }

          });

      }

      getSelectedVariant(productInfoNode) {

        const selectedVariant = productInfoNode.querySelector('variant-selects [data-selected-variant]')?.innerHTML;

        return !!selectedVariant ? JSON.parse(selectedVariant) : null;

      }

      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {

        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {

          params.push(`option_values=${optionValues.join(',')}`);

        }

        return `${url}?${params.join('&')}`;

      }

      updateOptionValues(html) {

        const variantSelects = html.querySelector('variant-selects');

        if (variantSelects) {

          HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);

        }

      }

      handleUpdateProductInfo(productUrl) {

        return (html) => {

          const variant = this.getSelectedVariant(html);

          this.pickupAvailability?.update(variant);

          this.updateOptionValues(html);

          this.updateURL(productUrl, variant?.id);

          this.updateVariantInputs(variant?.id);

          initVariantDrawer();

          if (!variant) {

            this.setUnavailable();

            return;

          }

          this.updateMedia(html, variant?.featured_media?.id);

          const updateSourceFromDestination = (id, shouldHide = (source) => false) => {

            const source = html.getElementById(`${id}-${this.sectionId}`);

            const destination = this.querySelector(`#${id}-${this.dataset.section}`);

            if (source && destination) {

              destination.innerHTML = source.innerHTML;

              destination.classList.toggle('hidden', shouldHide(source));

            }

          };

          // Re-initiate carousel arrows

          const sliderArrowsContainer = document.querySelector('.gallery-slider-arrows');

          if (sliderArrowsContainer) {

            sliderArrows();

          }

          // Re-initiate thumbnails scrolling

          const gstScroller = document.querySelector('.gst-scroller');

          if (gstScroller) {

            thumbnailsScroll();

          }

          // Re-initiate carousel pagination active states

          const slidesContainer = document.getElementById('SlidesCon');

          if (slidesContainer) {

            slidesContainer.addEventListener('scroll', function() {

              handleScroll(); // Call handleScroll function

            });

          }

          updateSourceFromDestination('price');

          updateSourceFromDestination('sticky-price');

          updateSourceFromDestination('stickyMedia');

          updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));

          updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');

          updateSourceFromDestination('Volume');

          updateSourceFromDestination('Price-Per-Item', ({ classList }) => classList.contains('hidden'));

          this.updateQuantityRules(this.sectionId, html);

          this.querySelector(`#Quantity-Rules-${this.dataset.section}`)?.classList.remove('hidden');

          this.querySelector(`#Volume-Note-${this.dataset.section}`)?.classList.remove('hidden');

          this.productForm?.toggleSubmitButton(

            html.getElementById(`ProductSubmitButton-${this.sectionId}`)?.hasAttribute('disabled') ?? true,

            window.variantStrings.soldOut

          );

          publish(PUB_SUB_EVENTS.variantChange, {

            data: {

              sectionId: this.sectionId,

              html,

              variant,

            },

          });

        };

      }

      updateVariantInputs(variantId) {

        this.querySelectorAll(

          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`

        ).forEach((productForm) => {

          const input = productForm.querySelector('input[name="id"]');

          input.value = variantId ?? '';

          input.dispatchEvent(new Event('change', { bubbles: true }));

        });

      }

      updateURL(url, variantId) {

        this.querySelector('share-button')?.updateUrl(

          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`

        );

        if (this.dataset.updateUrl === 'false') return;

        window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);

      }

      setUnavailable() {

        this.productForm?.toggleSubmitButton(true, window.variantStrings.unavailable);

        const selectors = ['price', 'Inventory', 'Sku', 'Price-Per-Item', 'Volume-Note', 'Volume', 'Quantity-Rules']

          .map((id) => `#${id}-${this.dataset.section}`)

          .join(', ');

        document.querySelectorAll(selectors).forEach(({ classList }) => classList.add('hidden'));

      }

      // Media Gallery Pagination

      handleScroll() {

        const slidesContainer = document.getElementById('SlidesCon');

        const slideWidth = slidesContainer.offsetWidth;

        const scrollPosition = slidesContainer.scrollLeft;

        const thumbnails = document.getElementsByClassName("gallery-slider--thumbnail");

        if (slidesContainer) {

          const index = Math.round(scrollPosition / slideWidth) + 1;

          pauseGalleryMedia();

          for (var i = 0; i < thumbnails.length; i++) {

            thumbnails[i].classList.remove("active");

            if (thumbnails[i].getAttribute('data-slide-index') == index) {

                thumbnails[i].classList.add("active");

            }

          }

        }

      }

      // Variant Selector Drawer

      initVariantDrawer() {

        const toggles = document.querySelectorAll('.radio-drawer--opener');

        const drawers = document.querySelectorAll('.radio-options-drawer');

        const closeButtons = document.querySelectorAll('.rod--drawer-close');

        const closeButtonsFooter = document.querySelectorAll('.rod--drawer-footer-button');

        const backgrounds = document.querySelectorAll('.radio-options-drawer--background');

        toggles.forEach(function (toggle, index) {

          const drawer = drawers[index];

          const closeButton = closeButtons[index];

          const closeButtonFooter = closeButtonsFooter[index];

          const drawerBg = backgrounds[index];

          if (!drawer) return;

          const isAccordion = drawer.classList.contains('ro-display-type--accordion');

          // If accordion, set up localStorage key

          let drawerKey;

          if (isAccordion) {

            const productId = document.querySelector('[data-product-id]')?.dataset.productId || 'unknown';

            drawerKey = `drawerOpen-${productId}-${index}`;

            // Restore open state from localStorage

            if (window.location.search.includes('variant=') && localStorage.getItem(drawerKey) === 'true') {

              drawer.classList.add('open');

              if (drawerBg) drawerBg.classList.add('open');

            }

          }

          const closeDrawer = () => {

            drawer.classList.remove('open');

            if (drawerBg) drawerBg.classList.remove('open');

            if (isAccordion) localStorage.setItem(drawerKey, 'false');

          };

          if (drawerBg) drawerBg.addEventListener("click", closeDrawer);

          if (closeButtonFooter) closeButtonFooter.addEventListener("click", closeDrawer);

          if (closeButton) closeButton.addEventListener("click", closeDrawer);

          toggle.addEventListener("click", function () {

            const isOpen = drawer.classList.toggle('open');

            if (drawerBg) drawerBg.classList.toggle('open', isOpen);

            if (isAccordion) localStorage.setItem(drawerKey, isOpen.toString());

          });

        });

      }

      updateMedia(html, variantFeaturedMediaId) {

        if (!variantFeaturedMediaId) return;

        const srcId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

        const galSource = html.getElementById(`pageGallery-${srcId}`);

        const galDestination = document.getElementById(`pageGallery-${this.dataset.section}`);

        if (!galSource || !galDestination) return;

        // Preserve the exact viewport while Shopify replaces the gallery.

        const xBefore = window.scrollX;

        const yBefore = window.scrollY;

        const previousHeight = galDestination.offsetHeight;

        if (previousHeight) {

          galDestination.style.minHeight = `${previousHeight}px`;

        }

        galDestination.innerHTML = galSource.innerHTML;

        requestAnimationFrame(() => {

          // Recalculate the responsive image height for the new variant.

          window.krimaaFitPdpMedia?.();

          if (

            Math.abs(window.scrollX - xBefore) > 1 ||

            Math.abs(window.scrollY - yBefore) > 1

          ) {

            window.scrollTo({

              left: xBefore,

              top: yBefore,

              behavior: 'auto'

            });

          }

          requestAnimationFrame(() => {

            galDestination.style.minHeight = '';

            window.krimaaFitPdpMedia?.();

          });

        });

      }

      setQuantityBoundries() {

        const data = {

          cartQuantity: this.quantityInput.dataset.cartQuantity ? parseInt(this.quantityInput.dataset.cartQuantity) : 0,

          min: this.quantityInput.dataset.min ? parseInt(this.quantityInput.dataset.min) : 1,

          max: this.quantityInput.dataset.max ? parseInt(this.quantityInput.dataset.max) : null,

          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,

        };

        let min = data.min;

        const max = data.max === null ? data.max : data.max - data.cartQuantity;

        if (max !== null) min = Math.min(min, max);

        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {

          this.quantityInput.max = max;

        } else {

          this.quantityInput.max = max; // Edited to always set a max attribute

        }

        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);

      }

      fetchQuantityRules() {

        const currentVariantId = this.productForm?.variantIdInput?.value;

        if (!currentVariantId) return;

        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');

        return fetch(`${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`)

          .then((response) => response.text())

          .then((responseText) => {

            const html = new DOMParser().parseFromString(responseText, 'text/html');

            this.updateQuantityRules(this.dataset.section, html);

          })

          .catch((e) => console.error(e))

          .finally(() => this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden'));

      }

      updateQuantityRules(sectionId, html) {

        if (!this.quantityInput) return;

        this.setQuantityBoundries();

        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);

        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];

        for (let selector of selectors) {

          const current = this.quantityForm.querySelector(selector);

          const updated = quantityFormUpdated.querySelector(selector);

          if (!current || !updated) continue;

          if (selector === '.quantity__input') {

            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];

            for (let attribute of attributes) {

              const valueUpdated = updated.getAttribute(attribute);

              if (valueUpdated !== null) {

                current.setAttribute(attribute, valueUpdated);

              } else {

                current.removeAttribute(attribute);

              }

            }

            // Edited - after updating attributes, reset boundaries

            this.setQuantityBoundries();

          } else {

            current.innerHTML = updated.innerHTML;

            if (selector === '.quantity__label') {

              const updatedAriaLabelledBy = updated.getAttribute('aria-labelledby');

              if (updatedAriaLabelledBy) {

                current.setAttribute('aria-labelledby', updatedAriaLabelledBy);

                // Update the referenced visually hidden element

                const labelId = updatedAriaLabelledBy;

                const currentHiddenLabel = document.getElementById(labelId);

                const updatedHiddenLabel = html.getElementById(labelId);

                if (currentHiddenLabel && updatedHiddenLabel) {

                  currentHiddenLabel.textContent = updatedHiddenLabel.textContent;

                }

              }

            }

          }

        }

      }

      get productForm() {

        return this.querySelector(`product-form`);

      }

      get productModal() {

        return document.querySelector(`#ProductModal-${this.dataset.section}`);

      }

      get pickupAvailability() {

        return this.querySelector(`pickup-availability`);

      }

      get variantSelectors() {

        return this.querySelector('variant-selects');

      }

      get relatedProducts() {

        const relatedProductsSectionId = SectionId.getIdForSection(

          SectionId.parseId(this.sectionId),

          'related-products'

        );

        return document.querySelector(`product-recommendations[data-section-id^="${relatedProductsSectionId}"]`);

      }

      get quickOrderList() {

        const quickOrderListSectionId = SectionId.getIdForSection(

          SectionId.parseId(this.sectionId),

          'quick_order_list'

        );

        return document.querySelector(`quick-order-list[data-id^="${quickOrderListSectionId}"]`);

      }

      get sectionId() {

        return this.dataset.originalSection || this.dataset.section;

      }

    }

  );

}

/* ============================================================

   KRIMAA PDP RESPONSIVE MEDIA + SCROLL-UP HEADER

   - Browser zoom / resize responsive

   - Uses the ACTUAL visible header bottom

   - Header hidden on scroll-down => media can sit near viewport top

   - Header returns on scroll-up => media moves below it

   - Variant refresh keeps page position

   ============================================================ */

(function () {

  if (window.__krimaaPdpMediaFixV2Ready) return;

  window.__krimaaPdpMediaFixV2Ready = true;

  const DESKTOP_QUERY = window.matchMedia('(min-width: 950px)');

  const PRODUCT_GAP = 12;

  let resizeFrame = null;

  let headerFrame = null;

  let headerFitTimer = null;

  let lastStickyTop = -1;

  function isVisible(el) {

    if (!el || !el.isConnected) return false;

    const style = getComputedStyle(el);

    if (

      style.display === 'none' ||

      style.visibility === 'hidden' ||

      parseFloat(style.opacity || '1') <= 0.01

    ) {

      return false;

    }

    const rect = el.getBoundingClientRect();

    return rect.width > 0 && rect.height > 0 && rect.bottom > 0;

  }

  function getVisibleHeaderBottom() {

    if (!DESKTOP_QUERY.matches) return 0;

    const selectors = [

      'header',

      '#shopify-section-header',

      '.shopify-section-group-header-group',

      '.header-wrapper',

      '.header-bar',

      '.header-bar--full',

      '.header-bar--page-margins',

      '.site-header',

      '.full-width-announcement-bar',

      '.header-announcement-bar',

      '.announcement-bar'

    ];

    const elements = new Set();

    selectors.forEach((selector) => {

      document.querySelectorAll(selector).forEach((el) => elements.add(el));

    });

    let bottom = 0;

    const viewportWidth = document.documentElement.clientWidth || window.innerWidth;

    elements.forEach((el) => {

      if (!isVisible(el)) return;

      if (el.closest('product-info')) return;

      const rect = el.getBoundingClientRect();

      // Only count wide elements that are currently occupying the top

      // part of the viewport. A hidden scroll-up header normally has

      // rect.bottom <= 0, so it is automatically ignored.

      if (rect.width < viewportWidth * 0.55) return;

      if (rect.top > 220) return;

      if (rect.bottom <= 0) return;

      if (rect.height > 260) return;

      bottom = Math.max(bottom, rect.bottom);

    });

    return Math.max(0, Math.min(bottom, 260));

  }

  function updateStickyHeaderOffset(force = false) {

    const visibleHeaderBottom = getVisibleHeaderBottom();

    const nextStickyTop = Math.round(visibleHeaderBottom + PRODUCT_GAP);

    if (!force && Math.abs(nextStickyTop - lastStickyTop) < 2) return false;

    lastStickyTop = nextStickyTop;

    document.documentElement.style.setProperty(

      '--krimaa-pdp-sticky-top',

      `${nextStickyTop}px`

    );

    // Refit after the scroll-up header finishes its transition.

    clearTimeout(headerFitTimer);

    headerFitTimer = setTimeout(fitAll, 140);

    return true;

  }

  function getMediaRatio(gallery) {

    if (gallery.classList.contains('pmc-portrait-4x6')) return 1.5;

    if (gallery.classList.contains('pmc-square')) return 1;

    if (gallery.classList.contains('pmc-landscape')) return 0.66;

    if (gallery.classList.contains('pmc-landscape-16x9')) return 0.5625;

    return 1.25; // portrait 4:5

  }

  function clearDesktopSizing(root) {

    const slides = root.querySelector('#SlidesCon');

    if (!slides) return;

    slides.querySelectorAll(':scope > .product-media-image').forEach((slide) => {

      slide.style.removeProperty('height');

      slide.style.removeProperty('padding-bottom');

    });

    const thumbScroller = root.querySelector('.gst-scroller');

    if (thumbScroller) thumbScroller.style.removeProperty('max-height');

  }

  function fitRoot(root) {

    if (!root || root.closest('.quick-add-modal')) return;

    const gallery = root.querySelector('.product-media-component');

    const slides = root.querySelector('#SlidesCon');

    if (!gallery || !slides) return;

    if (!DESKTOP_QUERY.matches) {

      clearDesktopSizing(root);

      return;

    }

    const sliderWidth = slides.clientWidth;

    if (!sliderWidth) return;

    let targetHeight = sliderWidth * getMediaRatio(gallery);

    if (gallery.classList.contains('pmc-mediascreen-height')) {

      const viewportHeight =

        window.visualViewport?.height ||

        document.documentElement.clientHeight ||

        window.innerHeight;

      const stickyTop = Math.max(

        PRODUCT_GAP,

        parseFloat(

          getComputedStyle(document.documentElement)

            .getPropertyValue('--krimaa-pdp-sticky-top')

        ) || PRODUCT_GAP

      );

      // Keep a small amount of breathing room at the bottom as well.

      const availableHeight = Math.max(

        320,

        viewportHeight - stickyTop - 16

      );

      targetHeight = Math.min(targetHeight, availableHeight);

    }

    targetHeight = Math.max(320, Math.round(targetHeight));

    slides.querySelectorAll(':scope > .product-media-image').forEach((slide) => {

      slide.style.setProperty('height', `${targetHeight}px`, 'important');

      slide.style.setProperty('padding-bottom', '0px', 'important');

    });

    const thumbScroller = root.querySelector('.gst-scroller');

    if (thumbScroller) {

      thumbScroller.style.setProperty('max-height', `${targetHeight}px`);

    }

  }

  function fitAll() {

    updateStickyHeaderOffset(true);

    document

      .querySelectorAll('product-info[id^="MainProduct"]')

      .forEach(fitRoot);

  }

  function scheduleFit() {

    if (resizeFrame) cancelAnimationFrame(resizeFrame);

    resizeFrame = requestAnimationFrame(() => {

      resizeFrame = null;

      fitAll();

    });

  }

  function scheduleHeaderUpdate() {

    if (headerFrame) cancelAnimationFrame(headerFrame);

    headerFrame = requestAnimationFrame(() => {

      headerFrame = null;

      updateStickyHeaderOffset();

    });

  }

  window.krimaaFitPdpMedia = fitAll;

  window.addEventListener('resize', scheduleFit, { passive: true });

  window.visualViewport?.addEventListener('resize', scheduleFit, { passive: true });

  // This is the important part for your "header appears only on scroll-up" setup.

  window.addEventListener('scroll', scheduleHeaderUpdate, { passive: true });

  document.addEventListener('shopify:section:load', scheduleFit);

  if (document.readyState === 'loading') {

    document.addEventListener('DOMContentLoaded', scheduleFit, { once: true });

  } else {

    scheduleFit();

  }

})();

/* ============================================================

   KRIMAA PRODUCT PAGE INTERACTION REHYDRATION

   Fixes:

   - section/product tabs after AJAX full-main product swap

   - lower-page inline scripts after product swap

   - mobile/desktop scroll position preservation support

   ============================================================ */

(function () {

  if (window.KrimaaProductPage?.interactionFixReady) return;

  const api = window.KrimaaProductPage || {};

  api.interactionFixReady = true;

  function isExecutableInlineScript(script) {

    if (script.src) return false;

    const type = (script.getAttribute('type') || '').trim().toLowerCase();

    return (

      type === '' ||

      type === 'text/javascript' ||

      type === 'application/javascript' ||

      type === 'module'

    );

  }

  function rerunInlineScripts(root) {

    if (!root) return;

    root.querySelectorAll('script').forEach((oldScript) => {

      if (!isExecutableInlineScript(oldScript)) return;

      if (oldScript.dataset.krimaaRehydrated === 'true') return;

      const newScript = document.createElement('script');

      Array.from(oldScript.attributes).forEach((attr) => {

        if (attr.name === 'data-krimaa-rehydrated') return;

        newScript.setAttribute(attr.name, attr.value);

      });

      newScript.dataset.krimaaRehydrated = 'true';

      newScript.textContent = oldScript.textContent;

      try {

        oldScript.replaceWith(newScript);

      } catch (e) {

        // Keep the page usable even if a third-party inline script cannot rerun.

      }

    });

  }

  function getTabButtons(tablist) {

    return Array.from(

      tablist.querySelectorAll(':scope > [role="tab"], [role="tab"]')

    ).filter((button) => button.closest('[role="tablist"]') === tablist);

  }

  function activateTab(tab, moveFocus = false) {

    if (!tab || tab.getAttribute('role') !== 'tab') return false;

    const tablist = tab.closest('[role="tablist"]');

    if (!tablist) return false;

    const targetId = tab.getAttribute('aria-controls');

    if (!targetId) return false;

    const targetPanel = document.getElementById(targetId);

    if (!targetPanel) return false;

    const buttons = getTabButtons(tablist);

    buttons.forEach((button) => {

      const selected = button === tab;

      button.setAttribute('aria-selected', selected ? 'true' : 'false');

      button.setAttribute('tabindex', selected ? '0' : '-1');

      const panelId = button.getAttribute('aria-controls');

      if (!panelId) return;

      const panel = document.getElementById(panelId);

      if (!panel) return;

      panel.hidden = !selected;

      panel.setAttribute('aria-hidden', selected ? 'false' : 'true');

      if (selected) {

        panel.removeAttribute('hidden');

      } else {

        panel.setAttribute('hidden', '');

      }

    });

    if (moveFocus) {

      try {

        tab.focus({ preventScroll: true });

      } catch (e) {}

    }

    return true;

  }

  // Document-level delegation survives complete <main> replacements.

  document.addEventListener(

    'click',

    function (event) {

      const tab = event.target.closest('[role="tab"]');

      if (!tab) return;

      // Only take over actual accessible tab controls.

      if (!tab.hasAttribute('aria-controls')) return;

      if (activateTab(tab, false)) {

        event.preventDefault();

      }

    },

    true

  );

  document.addEventListener(

    'keydown',

    function (event) {

      const tab = event.target.closest('[role="tab"]');

      if (!tab) return;

      const tablist = tab.closest('[role="tablist"]');

      if (!tablist) return;

      const buttons = getTabButtons(tablist);

      if (buttons.length < 2) return;

      const index = buttons.indexOf(tab);

      if (index < 0) return;

      let nextIndex = null;

      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {

        nextIndex = (index + 1) % buttons.length;

      } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {

        nextIndex = (index - 1 + buttons.length) % buttons.length;

      } else if (event.key === 'Home') {

        nextIndex = 0;

      } else if (event.key === 'End') {

        nextIndex = buttons.length - 1;

      }

      if (nextIndex === null) return;

      event.preventDefault();

      activateTab(buttons[nextIndex], true);

    },

    true

  );

  function normalizeTabs(root = document) {

    root.querySelectorAll('[role="tablist"]').forEach((tablist) => {

      const buttons = getTabButtons(tablist);

      if (!buttons.length) return;

      let selected =

        buttons.find((button) => button.getAttribute('aria-selected') === 'true') ||

        buttons[0];

      activateTab(selected, false);

    });

  }

  api.rehydrate = function () {

    const main = document.querySelector('main');

    // Re-run section-specific inline scripts that were inserted via AJAX.

    // Scripts with src are not duplicated; permanent event delegation above

    // handles the tabs even if their external initializer ran only once.

    rerunInlineScripts(main);

    normalizeTabs(main || document);

    // Recalculate product-media/header sizing from the previous fix.

    window.krimaaFitPdpMedia?.();

  };

  window.KrimaaProductPage = api;

  if (document.readyState === 'loading') {

    document.addEventListener(

      'DOMContentLoaded',

      function () {

        api.rehydrate();

      },

      { once: true }

    );

  } else {

    api.rehydrate();

  }

  document.addEventListener('shopify:section:load', function () {

    api.rehydrate();

  });

})();

/* ============================================================

   KRIMAA — LINKED PRODUCT NAVIGATION VIEWPORT RESTORE

   Cross-product shade changes intentionally use a real product-page

   navigation so CWILL/Trustoo receives the correct Shopify product context.

   Restore the previous viewport after the new product page has loaded.

   ============================================================ */

(function () {

  const STORAGE_KEY = 'krimaa:linked-product-navigation';

  function restoreLinkedProductViewport() {

    let state = null;

    try {

      state = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || 'null');

    } catch (e) {}

    if (!state || !state.path) return;

    // Ignore stale state and navigation to an unrelated product/page.

    if (Date.now() - Number(state.time || 0) > 10000 || location.pathname !== state.path) {

      try { sessionStorage.removeItem(STORAGE_KEY); } catch (e) {}

      return;

    }

    try { sessionStorage.removeItem(STORAGE_KEY); } catch (e) {}

    const restore = () => {

      const maxY = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);

      const targetY = Math.min(Number(state.y || 0), maxY);

      window.scrollTo({

        left: Number(state.x || 0),

        top: targetY,

        behavior: 'auto'

      });

    };

    requestAnimationFrame(() => {

      requestAnimationFrame(restore);

    });

    // Late corrections cover fonts/images/app widgets settling after load.

    setTimeout(restore, 120);

    setTimeout(restore, 350);

  }

  if (document.readyState === 'loading') {

    document.addEventListener('DOMContentLoaded', restoreLinkedProductViewport, { once: true });

  } else {

    restoreLinkedProductViewport();

  }

})();

/* ============================================================

   KRIMAA — TRUSTOO / VSTAR REVIEW TAB STABILITY

   The live Trustoo mount is preserved during cross-product swaps above.

   Do not clone/reload Trustoo scripts on every Reviews-tab click because

   that can create duplicate app instances and still leave the new mount blank.

   ============================================================ */

(function () {

  if (window.__krimaaReviewWidgetStabilityReady) return;

  window.__krimaaReviewWidgetStabilityReady = true;

  let frame = null;

  function nudgeReviewLayout() {

    if (frame) cancelAnimationFrame(frame);

    frame = requestAnimationFrame(() => {

      frame = null;

      const mount = document.querySelector('.custom-vstar-review-widget');

      if (!mount) return;

      // Recalculate widths/heights when the Reviews panel becomes visible

      // or after Shopify swaps the product information.

      window.dispatchEvent(new Event('resize'));

      try {

        mount.dispatchEvent(

          new CustomEvent('trustoo:refresh', { bubbles: true })

        );

      } catch (e) {}

    });

  }

  document.addEventListener('krimaa:reviews-tab-opened', nudgeReviewLayout);

  document.addEventListener('product-info:loaded', nudgeReviewLayout);

  document.addEventListener('shopify:section:load', nudgeReviewLayout);

  if (document.readyState === 'loading') {

    document.addEventListener('DOMContentLoaded', nudgeReviewLayout, { once: true });

  } else {

    nudgeReviewLayout();

  }

})();
